import { useCallback, useEffect, useState } from 'react'
import { doc, getDoc } from 'firebase/firestore/lite'
import { db } from '../lib/firebase'

/**
 * Fotos de la galería de la portada (colección `configuracion`, doc
 * `galeria`). Mismo patrón que useHero: lectura puntual, array vacío si el
 * doc no existe todavía (antes de que el admin suba algo desde /admin) — la
 * sección Galeria.jsx decide no renderizar nada en ese caso, en vez de
 * mostrar una grilla vacía.
 */
export function useGaleria() {
  const [imagenes, setImagenes] = useState([])
  const [cargando, setCargando] = useState(true)
  const [error, setError] = useState(null)

  const recargar = useCallback(() => {
    let vigente = true
    setCargando(true)
    setError(null)

    getDoc(doc(db, 'configuracion', 'galeria'))
      .then((snap) => {
        if (!vigente) return
        const datos = snap.exists() ? snap.data().imagenes : null
        setImagenes(Array.isArray(datos) ? datos : [])
        setCargando(false)
      })
      .catch((err) => {
        if (!vigente) return
        console.error('useGaleria:', err)
        setError('No pudimos cargar la galería.')
        setCargando(false)
      })

    return () => {
      vigente = false
    }
  }, [])

  useEffect(() => recargar(), [recargar])

  return { imagenes, cargando, error, recargar }
}
